// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2knd4","title":"styles_title__3rGXJ"};